import React, { useState, useEffect, Fragment } from "react";
import { Typography, Switch } from "@material-ui/core";

const Step1 = (props) => {
  const [value, setValue] = useState({
    presence_elec: false,
    presence_wifi: false,
    presence_tel: false,
  });

  useEffect(() => {
    // Quand le composant se charge, autorise à passer à la suite
    props.setAuthorization(true);
    // Insérer les réponses par défaut des switch dans la réponse
    for (let element in value) {
      props.result[element] = value[element];
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (event) => {
    // Set la value du state du composant local
    setValue({ ...value, [event.target.name]: event.target.checked });
    // Set la value du state du composant parent
    let newResult = props.result;
    newResult[event.target.name] = event.target.checked;
    props.setResult(newResult);
  };

  return (
    <Fragment>
      <Typography variant="body1" component="legend">
        J'indique la présence (rouge) ou le manque (gris) ...
      </Typography>
      <Typography variant="body1">Réseau électrique :</Typography>
      <Switch
        name="presence_elec"
        checked={value.presence_elec}
        onChange={handleChange}
      />
      <Typography variant="body1">Réseau Wi-Fi :</Typography>
      <Switch
        name="presence_wifi"
        checked={value.presence_wifi}
        onChange={handleChange}
      />
      <Typography variant="body1">Réseau téléphonique :</Typography>
      <Switch
        name="presence_tel"
        checked={value.presence_tel}
        onChange={handleChange}
      />
    </Fragment>
  );
};

export default Step1;
